export default {
  title: 'Télécharger l\'application',
  author: ' iA mobile',
  buttonLabel: 'Installer',
  closeButtonLabel: 'Fermer',
};
